import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tag16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.9999 6C10.9999 6.55228 10.5522 7 9.99988 7C9.44759 7 8.99988 6.55228 8.99988 6C8.99988 5.44772 9.44759 5 9.99988 5C10.5522 5 10.9999 5.44772 10.9999 6Z'
      fill='currentColor'
    />
    <path
      d='M5.96954 7.03033L8.96954 10.0303L10.0302 8.96967L7.0302 5.96967L5.96954 7.03033Z'
      fill='currentColor'
    />
    <path
      d='M6.96954 12.0303L3.96954 9.03033L5.0302 7.96967L8.0302 10.9697L6.96954 12.0303Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.20703 1.24994C7.87551 1.24994 7.55757 1.38163 7.32315 1.61605L0.823148 8.11606C0.334992 8.60421 0.334992 9.39567 0.823148 9.88382L6.11604 15.1767C6.6042 15.6649 7.39565 15.6649 7.88381 15.1767L14.3838 8.67672C14.6182 8.4423 14.7499 8.12435 14.7499 7.79283V2.49994C14.7499 1.80958 14.1903 1.24994 13.4999 1.24994H8.20703ZM2.06058 8.99994L8.31059 2.74994H13.2499V7.68928L6.99992 13.9393L2.06058 8.99994Z'
      fill='currentColor'
    />
  </Svg>
);

Tag16.displayName = 'Tag16';
export default Tag16;
